import { render, staticRenderFns } from "./businessManage.vue?vue&type=template&id=5ceb4636"
import script from "./businessManage.vue?vue&type=script&lang=js"
export * from "./businessManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports